import { useMemo } from "react";
import { useEnvironment } from "./useEnvironment.js";
import { QueryLanguage } from "../queryLanguage/QueryLanguage.js";
function useDesugaredRelativeSingleEntity(sugaredRelativeSingleEntity) {
  const environment = useEnvironment();
  let normalizedSugared = void 0;
  let hasEntity;
  if (sugaredRelativeSingleEntity === void 0) {
    hasEntity = false;
  } else if (typeof sugaredRelativeSingleEntity === "string") {
    hasEntity = true;
    normalizedSugared = {
      field: sugaredRelativeSingleEntity
    };
  } else {
    hasEntity = true;
    normalizedSugared = sugaredRelativeSingleEntity;
  }
  return useMemo(
    () => hasEntity ? QueryLanguage.desugarRelativeSingleEntity(
      {
        field: normalizedSugared.field,
        isNonbearing: normalizedSugared?.isNonbearing,
        setOnCreate: normalizedSugared?.setOnCreate
      },
      environment
    ) : void 0,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [normalizedSugared?.field, normalizedSugared?.isNonbearing, normalizedSugared?.setOnCreate, environment, hasEntity]
  );
}
export {
  useDesugaredRelativeSingleEntity
};
//# sourceMappingURL=useDesugaredRelativeSingleEntity.js.map
